import axios from 'axios';

type MessageRequest = {
  name?: string | undefined
  email: string
  phoneNumber?: string | undefined
  message: string
}

export const sendMessage = (request: MessageRequest, captcha: string) => {
  return axios.post<MessageRequest>(
    "/messages",
    request,
    {
      baseURL: process.env.NEXT_PUBLIC_API_URL,
      headers: {
        Accept: 'application/json',
        Captcha: captcha
      }
    },
  )
}
